<template>
    <div class="container-fluid">
        <h1 class="text-left">{{ $t('menuItemSettings') }}</h1>
        <br />
        <b-form
            ref="mainsettingsform"
            name="mainSettingsForm"
            v-on:submit.prevent="$_onSubmit"
            class="pb-5"
        >
            <div class="col-md-12">
                <!-- PDOK -->
                <h4 class="first-group-label">{{ $t('mainSettings.labelPdok') }}</h4>
                <!-- PDOK Locationserver -->
                <div class="form-group">
                    <TextInput
                        :text="$t('mainSettings.labelPdokLocationServer')"
                        v-model="appSettings.pdokLocationServer"
                        :id="'pdoklocationserver'"
                        :name="'pdoklocationserver'"
                        :maxlength="255"
                    >
                    </TextInput>
                </div>
                <!-- PDOK Cadaster Wfs-Url -->
                <div class="form-group">
                    <TextInput
                        :text="$t('mainSettings.labelPdokCadasterWfsUrl')"
                        v-model="appSettings.pdokCadasterWfsUrl"
                        :id="'namePdokCadasterWfsUrl'"
                        :name="'namePdokCadasterWfsUrl'"
                        :maxlength="255"
                    >
                    </TextInput>
                </div>
                <!-- PDOK Cadaster parcel feature -->
                <div class="form-group">
                    <TextInput
                        :text="$t('mainSettings.labelPdokCadasterWfsFeaturetype')"
                        v-model="appSettings.pdokCadasterWfsFeaturetype"
                        :id="'namePdokCadasterWfsFeaturetype'"
                        :name="'namePdokCadasterWfsFeaturetype'"
                        :maxlength="255"
                    >
                    </TextInput>
                </div>

                <!-- FME -->
                <h4 class="group-label">{{ $t('mainSettings.labelFme') }}</h4>
                <!-- FME Upload-Url -->
                <div class="form-group">
                    <TextInput
                        :text="$t('mainSettings.labelFmeFileUploadUrl')"
                        v-model="appSettings.fmeFileUploadUrl"
                        :id="'fmeuploadlocationurl'"
                        :name="'fmeuploadlocationurl'"
                        :maxlength="255"
                    >
                    </TextInput>
                </div>
                <!-- FME Token -->
                <div class="form-group">
                    <TextInput
                        :text="$t('mainSettings.labelFmeToken')"
                        v-model="appSettings.fmeToken"
                        :id="'fmetoken'"
                        :name="'fmetoken'"
                        :maxlength="255"
                    >
                    </TextInput>
                </div>

                <!-- Save/cancel/remove buttons -->
                <SubmitCancelRemove
                    :is-saving="isSaving"
                    :is-deleting="false"
                    :mode="0"
                    :isBtnSaveDisabled="isBtnSaveDisabled"
                    @cancel="$_onCancel"
                >
                </SubmitCancelRemove>
            </div>
        </b-form>
    </div>
</template>

<script>
    import { nprogress } from '../../services/utilities';
    import TextInput from '../../components/BaseComponents/x-input.vue';
    import SubmitCancelRemove from '../../components/SubmitCancelRemove.vue';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';

    export default {
        name: 'MainSettings',
        mixins: [modalMixin],
        components: {
            TextInput,
            SubmitCancelRemove
        },

        data: function () {
            return {
                dbSetings: [],
                appSettings: {
                    pdokLocationServer: '',
                    pdokCadasterWfsUrl: '',
                    pdokCadasterWfsFeaturetype: '',
                    fmeFileUploadUrl: '',
                    fmeToken: ''
                },
                appSettingsName: {
                    pdokLocationServer: 'PdokLocationServer',
                    pdokCadasterWfsUrl: 'PdokCadasterWfsUrl',
                    pdokCadasterWfsFeaturetype: 'PdokCadasterWfsFeaturetype',
                    fmeFileUploadUrl: 'FmeFileUploadUrl',
                    fmeToken: 'FmeToken'
                },
                sortBy: 'name',
                searchText: '',
                isSaving: false,
                isResolved: false
            };
        },

        computed: {
            noData() {
                return (
                    this.isResolved &&
                    this.appSettings &&
                    this.appSettings.length === 0
                );
            },

            isBtnSaveDisabled: function () {
                return this.isSaving;
            }
        },

        async created() {
            nprogress.start();
            const appSettings = await this.$store.dispatch('useApiData', {
                name: 'GetAppSettings'
            });
            this.$_initDbSettings();
            this.$_copySettings(appSettings.data, this.dbSetings);
            this.$_processAppSettings(this.dbSetings);

            this.isResolved = true;
            nprogress.done();
        },

        methods: {
            $_initDbSettings() {
                this.dbSetings.push({ name: this.appSettingsName.pdokLocationServer, value: '' });
                this.dbSetings.push({ name: this.appSettingsName.pdokCadasterWfsUrl, value: '' });
                this.dbSetings.push({ name: this.appSettingsName.pdokCadasterWfsFeaturetype, value: '' });
                this.dbSetings.push({ name: this.appSettingsName.fmeFileUploadUrl, value: '' });
                this.dbSetings.push({ name: this.appSettingsName.fmeToken, value: '' });
            },

            $_copySettings(fromSettings, toSettings) {
                fromSettings.forEach((fromItem) => {
                    toSettings.forEach((toItem) => {
                        if (fromItem.name === toItem.name) {
                            toItem.value = fromItem.value;
                        }
                    });
                });
            },

            $_goToOverview() {
                this.$router.push({ path: '/dashboard' });
            },

            $_onCancel: function () {
                this.$_goToOverview();
            },

            $_processAppSettings(appSettings) {
                appSettings.forEach((item) => {
                    if (item.name === this.appSettingsName.pdokLocationServer) {
                        this.appSettings.pdokLocationServer = item.value;
                    } else if (item.name === this.appSettingsName.pdokCadasterWfsUrl) {
                        this.appSettings.pdokCadasterWfsUrl = item.value;
                    } else if (item.name === this.appSettingsName.pdokCadasterWfsFeaturetype) {
                        this.appSettings.pdokCadasterWfsFeaturetype = item.value;
                    } else if (item.name === this.appSettingsName.fmeFileUploadUrl) {
                        this.appSettings.fmeFileUploadUrl = item.value;
                    } else if (item.name === this.appSettingsName.fmeToken) {
                        this.appSettings.fmeToken = item.value;
                    }
                });
            },

            $_convertAppSettings() {
                this.dbSetings.forEach((item) => {
                    if (item.name === this.appSettingsName.pdokLocationServer) {
                        item.value = this.appSettings.pdokLocationServer;
                    } else if (item.name === this.appSettingsName.pdokCadasterWfsUrl) {
                        item.value = this.appSettings.pdokCadasterWfsUrl;
                    } else if (item.name === this.appSettingsName.pdokCadasterWfsFeaturetype) {
                        item.value = this.appSettings.pdokCadasterWfsFeaturetype;
                    } else if (item.name === this.appSettingsName.fmeFileUploadUrl) {
                        item.value = this.appSettings.fmeFileUploadUrl;
                    } else if (item.name === this.appSettingsName.fmeToken) {
                        item.value = this.appSettings.fmeToken;
                    }
                });
                return this.dbSetings;
            },

            $_onSubmit() {
                if (this.$refs.mainsettingsform.checkValidity()) {
                    this.$_onSave(false);
                }
            },

            async $_onSave() {
                this.isSaving = true;

                const data = this.$_convertAppSettings();
                const name = 'UpdateAppSettings';
                try {
                    await this.$store.dispatch('useApiData', {
                        name,
                        data
                    });
                    const messageData = {
                        message: this.$t('mainSettings.saved'),
                        variant: 'success',
                        autoHideDelay: 5000
                    };
                    this.showToast(messageData);
                    this.isSaving = false;
                } catch (error) {
                    console.log('Error saving settings: ', error);
                }
            }
        }
    };
</script>

<style scoped>
.img-fluid {
    max-width: 100px !important;
    max-height: 35px !important;
}
.first-group-label {
    margin-bottom: 5px;
}
.group-label {
    padding-top: 10px;
    margin-bottom: 5px;
}
</style>
